/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateLabOrderRequest,
  HTTPValidationError,
  LabOrderListResponse,
  LabOrderResponse,
  NotificationWithLinksResponse,
  PatchLabOrderV1LabsOrdersOrderIdPatchBody
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * List all laboratory orders for the authenticated user.

Returns a list of all orders (including cancelled ones) for the user,
ordered by creation date descending (newest first).
 * @summary List Lab Orders
 */
export const listLabOrdersV1LabsOrdersGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LabOrderListResponse>(
      {url: `/v1/labs/orders`, method: 'GET', signal
    },
      );
    }
  

export const getListLabOrdersV1LabsOrdersGetQueryKey = () => {
    return [`/v1/labs/orders`] as const;
    }

    
export const getListLabOrdersV1LabsOrdersGetQueryOptions = <TData = Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLabOrdersV1LabsOrdersGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>> = ({ signal }) => listLabOrdersV1LabsOrdersGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListLabOrdersV1LabsOrdersGetQueryResult = NonNullable<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>>
export type ListLabOrdersV1LabsOrdersGetQueryError = unknown


export function useListLabOrdersV1LabsOrdersGet<TData = Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>,
          TError,
          Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListLabOrdersV1LabsOrdersGet<TData = Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>,
          TError,
          Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListLabOrdersV1LabsOrdersGet<TData = Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Lab Orders
 */

export function useListLabOrdersV1LabsOrdersGet<TData = Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLabOrdersV1LabsOrdersGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListLabOrdersV1LabsOrdersGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new laboratory order in patient_details_collected state.

This endpoint creates a new lab order with patient details. The order starts in
the patient_details_collected state and can be modified before confirmation.
 * @summary Create Lab Order
 */
export const createLabOrderV1LabsOrdersPost = (
    createLabOrderRequest: CreateLabOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LabOrderResponse>(
      {url: `/v1/labs/orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLabOrderRequest, signal
    },
      );
    }
  


export const getCreateLabOrderV1LabsOrdersPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLabOrderV1LabsOrdersPost>>, TError,{data: CreateLabOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLabOrderV1LabsOrdersPost>>, TError,{data: CreateLabOrderRequest}, TContext> => {

const mutationKey = ['createLabOrderV1LabsOrdersPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLabOrderV1LabsOrdersPost>>, {data: CreateLabOrderRequest}> = (props) => {
          const {data} = props ?? {};

          return  createLabOrderV1LabsOrdersPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLabOrderV1LabsOrdersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createLabOrderV1LabsOrdersPost>>>
    export type CreateLabOrderV1LabsOrdersPostMutationBody = CreateLabOrderRequest
    export type CreateLabOrderV1LabsOrdersPostMutationError = HTTPValidationError

    /**
 * @summary Create Lab Order
 */
export const useCreateLabOrderV1LabsOrdersPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLabOrderV1LabsOrdersPost>>, TError,{data: CreateLabOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLabOrderV1LabsOrdersPost>>,
        TError,
        {data: CreateLabOrderRequest},
        TContext
      > => {

      const mutationOptions = getCreateLabOrderV1LabsOrdersPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get details of a specific laboratory order.

Returns full details of the specified order if it belongs to the authenticated user.
 * @summary Get Lab Order
 */
export const getLabOrderV1LabsOrdersOrderIdGet = (
    orderId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LabOrderResponse>(
      {url: `/v1/labs/orders/${orderId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetLabOrderV1LabsOrdersOrderIdGetQueryKey = (orderId?: string,) => {
    return [`/v1/labs/orders/${orderId}`] as const;
    }

    
export const getGetLabOrderV1LabsOrdersOrderIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError = HTTPValidationError>(orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabOrderV1LabsOrdersOrderIdGetQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>> = ({ signal }) => getLabOrderV1LabsOrdersOrderIdGet(orderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLabOrderV1LabsOrdersOrderIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>>
export type GetLabOrderV1LabsOrdersOrderIdGetQueryError = HTTPValidationError


export function useGetLabOrderV1LabsOrdersOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError = HTTPValidationError>(
 orderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderV1LabsOrdersOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderV1LabsOrdersOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Lab Order
 */

export function useGetLabOrderV1LabsOrdersOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV1LabsOrdersOrderIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLabOrderV1LabsOrdersOrderIdGetQueryOptions(orderId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Patch a laboratory order with various operations.

Supported operations:
- select_psc: Select a patient service center (transitions patient_details_collected -> psc_selected)
- change_patient_details: Update patient information (allowed in patient_details_collected or psc_selected states)
- confirm_order: Confirm order and create requisition in Junction (transitions psc_selected -> requisition_created)
- cancel_order: Cancel the order (transitions to cancelled state)
 * @summary Patch Lab Order
 */
export const patchLabOrderV1LabsOrdersOrderIdPatch = (
    orderId: string,
    patchLabOrderV1LabsOrdersOrderIdPatchBody: PatchLabOrderV1LabsOrdersOrderIdPatchBody,
 ) => {
      
      
      return customCatchBackendFetcher<LabOrderResponse>(
      {url: `/v1/labs/orders/${orderId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchLabOrderV1LabsOrdersOrderIdPatchBody
    },
      );
    }
  


export const getPatchLabOrderV1LabsOrdersOrderIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLabOrderV1LabsOrdersOrderIdPatch>>, TError,{orderId: string;data: PatchLabOrderV1LabsOrdersOrderIdPatchBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchLabOrderV1LabsOrdersOrderIdPatch>>, TError,{orderId: string;data: PatchLabOrderV1LabsOrdersOrderIdPatchBody}, TContext> => {

const mutationKey = ['patchLabOrderV1LabsOrdersOrderIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchLabOrderV1LabsOrdersOrderIdPatch>>, {orderId: string;data: PatchLabOrderV1LabsOrdersOrderIdPatchBody}> = (props) => {
          const {orderId,data} = props ?? {};

          return  patchLabOrderV1LabsOrdersOrderIdPatch(orderId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchLabOrderV1LabsOrdersOrderIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof patchLabOrderV1LabsOrdersOrderIdPatch>>>
    export type PatchLabOrderV1LabsOrdersOrderIdPatchMutationBody = PatchLabOrderV1LabsOrdersOrderIdPatchBody
    export type PatchLabOrderV1LabsOrdersOrderIdPatchMutationError = HTTPValidationError

    /**
 * @summary Patch Lab Order
 */
export const usePatchLabOrderV1LabsOrdersOrderIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLabOrderV1LabsOrdersOrderIdPatch>>, TError,{orderId: string;data: PatchLabOrderV1LabsOrdersOrderIdPatchBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchLabOrderV1LabsOrdersOrderIdPatch>>,
        TError,
        {orderId: string;data: PatchLabOrderV1LabsOrdersOrderIdPatchBody},
        TContext
      > => {

      const mutationOptions = getPatchLabOrderV1LabsOrdersOrderIdPatchMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get the PDF requisition form for a laboratory order.

Returns the PDF file for the requisition if the order belongs to the authenticated user
and has a requisition created in Junction.
 * @summary Get Lab Order Requisition Pdf
 */
export const getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet = (
    orderId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<unknown>(
      {url: `/v1/labs/orders/${orderId}/requisition`, method: 'GET', signal
    },
      );
    }
  

export const getGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGetQueryKey = (orderId?: string,) => {
    return [`/v1/labs/orders/${orderId}/requisition`] as const;
    }

    
export const getGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGetQueryOptions = <TData = Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError = HTTPValidationError>(orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGetQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>> = ({ signal }) => getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet(orderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>>
export type GetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGetQueryError = HTTPValidationError


export function useGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet<TData = Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError = HTTPValidationError>(
 orderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet<TData = Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet<TData = Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Lab Order Requisition Pdf
 */

export function useGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet<TData = Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLabOrderRequisitionPdfV1LabsOrdersOrderIdRequisitionGetQueryOptions(orderId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get the PDF results form for a laboratory order.

Returns the PDF file for the results if the order belongs to the authenticated user
and has a requisition created in Junction.
 * @summary Get Lab Order Results Pdf
 */
export const getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet = (
    orderId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<unknown>(
      {url: `/v1/labs/orders/${orderId}/results`, method: 'GET', signal
    },
      );
    }
  

export const getGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGetQueryKey = (orderId?: string,) => {
    return [`/v1/labs/orders/${orderId}/results`] as const;
    }

    
export const getGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGetQueryOptions = <TData = Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError = HTTPValidationError>(orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGetQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>> = ({ signal }) => getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet(orderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>>
export type GetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGetQueryError = HTTPValidationError


export function useGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet<TData = Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError = HTTPValidationError>(
 orderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet<TData = Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet<TData = Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Lab Order Results Pdf
 */

export function useGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet<TData = Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderResultsPdfV1LabsOrdersOrderIdResultsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLabOrderResultsPdfV1LabsOrdersOrderIdResultsGetQueryOptions(orderId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get all notifications associated with a specific laboratory order.

Returns notifications linked to this lab order if it belongs to the authenticated user.
 * @summary Get Lab Order Notifications
 */
export const getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet = (
    orderId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<NotificationWithLinksResponse[]>(
      {url: `/v1/labs/orders/${orderId}/notifications`, method: 'GET', signal
    },
      );
    }
  

export const getGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGetQueryKey = (orderId?: string,) => {
    return [`/v1/labs/orders/${orderId}/notifications`] as const;
    }

    
export const getGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGetQueryOptions = <TData = Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError = HTTPValidationError>(orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGetQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>> = ({ signal }) => getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet(orderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>>
export type GetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGetQueryError = HTTPValidationError


export function useGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet<TData = Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError = HTTPValidationError>(
 orderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet<TData = Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet<TData = Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Lab Order Notifications
 */

export function useGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet<TData = Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError = HTTPValidationError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLabOrderNotificationsV1LabsOrdersOrderIdNotificationsGetQueryOptions(orderId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



